import React, { useState, useEffect } from 'react';
import Post from './Post.js';
import { useTheme } from '../App';

function Feed({ posts, loading, selectedIndex, postRefs, onSelectPost }) {
  const { theme } = useTheme();
  const [loaderFrame, setLoaderFrame] = useState(0);

  const loaderFrames = [
    '[■□□□□□□□□□]', '[■■□□□□□□□□]', '[■■■□□□□□□□]', '[■■■■□□□□□□]', '[■■■■■□□□□□]',
    '[■■■■■■□□□□]', '[■■■■■■■□□□]', '[■■■■■■■■□□]', '[■■■■■■■■■□]', '[■■■■■■■■■■]',
  ];

  useEffect(() => {
    let interval;
    if (loading) {
      interval = setInterval(() => {
        setLoaderFrame(prevFrame => (prevFrame + 1) % loaderFrames.length);
      }, 100);
    }
    return () => clearInterval(interval);
  }, [loading, loaderFrames.length]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px', color: theme.colors.foreground }}>
        <div style={{ display: 'inline-block' }}>
          {loaderFrames[loaderFrame]} Loading feed...
        </div>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '20px', color: theme.colors.foreground }}>
        No posts found. Try another subreddit.
      </div>
    );
  }

  return (
    <div>
      {posts.map((post, index) => (
        <Post
          key={post.data.id}
          post={post.data}
          index={index}
          isSelected={index === selectedIndex}
          onSelect={() => onSelectPost(post.data)}
          ref={el => postRefs.current[index] = el}
        />
      ))}
    </div>
  );
}

export default Feed;